import styled from 'styled-components';
import { getColor } from '@yoweb/ui/styles/utils/theme';
import { ButtonIcon } from '@yoweb/ui/components/buttons/ButtonIcon';
import { ArrowLeftCompactIcon, ArrowRightCompactIcon } from '@yoweb/ui/components/Icon';
import { pxToRem } from '@yoweb/ui/styles/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CardCarouselNav = function CardCarouselNav(_ref) {
  var onNext = _ref.onNext,
      onPrevious = _ref.onPrevious,
      backwardEnabled = _ref.backwardEnabled,
      forwardEnabled = _ref.forwardEnabled;
  return /*#__PURE__*/_jsxs(ButtonWrap, {
    children: [/*#__PURE__*/_jsx(NavButton, {
      "data-testid": "carousel-backwards-button",
      icon: /*#__PURE__*/_jsx(ArrowLeftCompactIcon, {
        size: 20,
        variant: "fg"
      }),
      disabled: !backwardEnabled,
      onClick: onPrevious,
      size: "md"
    }), /*#__PURE__*/_jsx(NavButton, {
      "data-testid": "carousel-forwards-button",
      icon: /*#__PURE__*/_jsx(ArrowRightCompactIcon, {
        size: 20,
        variant: "fg"
      }),
      disabled: !forwardEnabled,
      onClick: onNext,
      size: "md"
    })]
  });
};
var ButtonWrap = styled.div.withConfig({
  componentId: "sc-14hpo07-0"
})(["display:flex;button:first-child{margin-right:", ";}"], pxToRem(10));
var NavButton = styled(ButtonIcon).withConfig({
  componentId: "sc-14hpo07-1"
})(["border:1.875px solid;border-color:", ";background-color:", ";color:", ";box-shadow:none !important;&:focus{::after{border:none;}}&:hover{border-color:", ";background-color:", ";color:", ";}&:disabled{background-color:", ";color:", ";border:1.875px solid ", ";pointer-events:none;svg{color:", ";}}"], getColor('sandMedium'), getColor('base000'), getColor('sandDark'), getColor('base1000'), getColor('baseA050'), getColor('base1000'), getColor('sand'), getColor('base400'), getColor('sandMedium'), getColor('base200'));